import React from 'react';

import { getBrandLogoSrc } from 'utils/brandLogo';

const SplashScreen = () => {
  return (
    <div id="splash-screen">
      <div className="center">
        <div className="logo">
          {/* No width here: the splash's size and position are owned by the #splash-screen CSS in
              public/index.html, so this renders IDENTICALLY to the pre-React splash it replaces.
              A width of its own is what made the two differ and the logo jump on mount (DEV-5584). */}
          <img alt="logo" src={getBrandLogoSrc()} />
        </div>
        <div className="spinner-wrapper">
          <div className="spinner">
            <div className="inner">
              <div className="gap" />
              <div className="left">
                <div className="half-circle" />
              </div>
              <div className="right">
                <div className="half-circle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SplashScreen);
